import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '../views/About'
import Project from '../views/Projects'
import Experience from '../views/Experiences'
import Skill from '../views/Skills'
import Login from '../views/Login'

Vue.use(VueRouter)

export default new VueRouter({
    routes:[
        { path: '/', name: 'About', component: About },
        { path: '/project', name: 'Projects', component: Project },
        { path: '/experience', name: 'Experiences', component: Experience },
        { path: '/skill', name: 'Skills', component: Skill },
        { path: '/login', name: 'Login', component: Login },
    ],
    mode: 'hash'
})